import { Controller } from "@hotwired/stimulus"

// Máscaras de padrão fixo via IMask.
const IMASKS = {
  cpf:           { mask: "000.000.000-00" },
  cnpj:          { mask: "00.000.000/0000-00" },
  phone:         { mask: [{ mask: "(00) 0000-0000" }, { mask: "(00) 00000-0000" }] },
  cep:           { mask: "00000-000" },
  card:          { mask: "0000 0000 0000 0000" },
  cardPassword:  { mask: "0000" },
  numeracao:     { mask: /^\d+$/ },
  codigoRecurso: { mask: "00.000.00.000.0000.0.000" }
}

// Tipos monetários: preenchem 2 casas decimais da direita p/ esquerda (igual ao
// maskMoney/jquery.mask reverse antigos). O servidor (UtilService.to_float) remove
// separadores e divide por 100, então a string precisa ser idêntica à de antes.
const CURRENCY = {
  money:      { thousands: "." },
  percentage: { thousands: "" },
  litros:     { thousands: "" }
}

export default class extends Controller {
  static values = { type: String }

  connect() {
    if (typeof IMask === "undefined") return
    const cur = CURRENCY[this.typeValue]
    if (cur) { this._connectCurrency(cur); return }
    const opts = IMASKS[this.typeValue]
    if (opts) this.mask = IMask(this.element, opts)
  }

  disconnect() {
    if (this.mask) { this.mask.destroy(); this.mask = null }
    if (this._currencyHandler) {
      this.element.removeEventListener("input", this._currencyHandler)
      this._currencyHandler = null
    }
  }

  _connectCurrency({ thousands }) {
    const el = this.element
    const format = () => {
      const digits = el.value.replace(/\D/g, "")
      if (!digits) { el.value = ""; return }
      const padded = digits.padStart(3, "0")
      const cents = padded.slice(-2)
      let int = padded.slice(0, -2).replace(/^0+(?=\d)/, "")
      if (thousands) int = int.replace(/\B(?=(\d{3})+(?!\d))/g, thousands)
      el.value = `${int},${cents}`
    }
    this._currencyHandler = format
    el.addEventListener("input", format)
    if (el.value) format() // formata valor pré-preenchido (re-render)
  }
}
